import { Route, Routes } from "react-router-dom";
import UserAccessManagementDashboard from "../pages/UserAccessManagementDashboard/UserAccessManagementDashboard";
import AuditLogs from "../pages/AuditLogs/AuditLogs";
import BulkEditFragrances from "../pages/BulkEditFragrances/BulkEditFragrances";
import BulkEditAssociations from "../pages/BulkEditAssociations/BulkEditAssociations";
import BulkRenameFields from "../pages/BulkRenameFields/BulkRenameFields.js";
import { forwardRef } from "react";

const RoutesComponent = forwardRef((props, ref) => {
  return (
    <>
      <Routes>
        <Route path="/" element={<UserAccessManagementDashboard />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route
          path="/bulk-edit-fragrances"
          element={<BulkEditFragrances ref={ref} />}
        />
        <Route
          path="/bulk-edit-associations"
          element={<BulkEditAssociations ref={ref} />}
        />
        <Route path="/rename-fragrance-fields" element={<BulkRenameFields />} />
      </Routes>
    </>
  );
});

export default RoutesComponent;
